import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
type KVPTablePropsRecord = {
  label: React.ReactNode;
  value: React.ReactNode;
};
export type KVPTableProps = {
  records: KVPTablePropsRecord[];
};
function VehicleKVPTableRow(t0) {
  const $ = _c(8);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      fontWeight: "bold"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <TableCell sx={t1}>{label}</TableCell>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== value) {
    t3 = <TableCell>{value}</TableCell>;
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <TableRow>{t2}{t3}</TableRow>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function VehicleKVPTableRows({
  records
}: KVPTableProps) {
  return records.map((record, index) => <VehicleKVPTableRow key={index} label={record.label} value={record.value} />);
}
export function VehicleKVPTable(t0) {
  const $ = _c(3);
  const {
    records
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mt: 2,
      mb: 2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== records) {
    t2 = <Table sx={t1} size="small"><TableBody><VehicleKVPTableRows records={records} /></TableBody></Table>;
    $[1] = records;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}